module.exports = __webpack_public_path__ + "media/images/area/maps/chubu-41f10d49394dc44d15073d8eb127e5d9.svg";